import { z } from 'zod';
// Channel timeline — spec §0a.9 lane 1.
//
// One row per channel-event Mag operated on (or scheduled). Past +
// future. The home page consumes this via a single endpoint that fans
// out across feed_cards + campaigns.draft jsonb + future brand_memos.
//
// Each event carries enough to render a one-line summary + deep-link
// the founder into the detail view. Specifics (engagement, spend, etc.)
// ride in the kind-specific `payload`. Renderers switch on `kind`.
export const channelTimelineEventKindSchema = z.enum([
    'instagram_post_published',
    'instagram_post_scheduled',
    'meta_paid_ad_launched',
    'meta_paid_ad_paused',
    'google_search_ad_launched',
    'google_search_ad_paused',
    'creative_drop_published',
    // memo_published lands in session B once brand_memos ships. Stubbed
    // here so the union is forward-compatible.
    'memo_published',
]);
export const channelTimelineChannelSchema = z.enum([
    'instagram',
    'meta_paid',
    'google_paid',
    'magig',
]);
const baseEventFields = {
    kind: channelTimelineEventKindSchema,
    channel: channelTimelineChannelSchema,
    /** Sort key. ISO datetime for instant events; ISO date at midnight
     *  brand-tz for date-only events (e.g. scheduled posts whose hour
     *  is tracked separately in payload). */
    at: z.string(),
    /** Future-tense for scheduled events. The renderer doesn't have to
     *  derive "past vs future" — this flag is authoritative. */
    tense: z.enum(['past', 'future']),
    /** Mag-voice one-liner. Lower-case, no terminal period unless the
     *  string is a sentence. Renderer puts it verbatim in the row. */
    summary: z.string().min(1).max(280),
    /** Deep-link path within the dashboard. Renderer prepends the
     *  brand-scoped prefix. Empty string when no useful drill-down
     *  exists (e.g. analytics milestones). */
    deepLink: z.string().max(512),
    /** Optional id linking back to the source row — feed_card.id,
     *  campaign.id + deliverable_id concat, etc. Used for dedup +
     *  click→detail-fetch. */
    sourceId: z.string().optional(),
};
export const channelTimelineEventSchema = z.object({
    ...baseEventFields,
    /** Kind-specific extras. Schema-light by design — the renderers know
     *  what to expect per kind, and we don't want to migrate the timeline
     *  whenever a new field lands on the underlying source. */
    payload: z.record(z.string(), z.unknown()).optional(),
});
export const channelTimelineResponseSchema = z.object({
    events: z.array(channelTimelineEventSchema),
    /** Timestamp the aggregator ran, for renderer's "as of" footer. */
    fetchedAt: z.string().datetime(),
    /** Window the events span. Helps the renderer say "past 2 weeks +
     *  upcoming". */
    rangeStart: z.string().datetime(),
    rangeEnd: z.string().datetime(),
});
//# sourceMappingURL=channel-timeline.js.map